export default __webpack_public_path__ + "static/media/kitchenisland.8a5e32e7.svg";